import { useEffect, useState } from 'react'
import { getExpoMediaList, MEDIA_TYPE } from '../api/guardianExpoService'

/**
 * 取得護博會子頁面（市集／講座／挑戰賽）的活動影音＋活動圖片
 * @param {number} expoEvent EXPO_EVENT.LECTURE / CHALLENGE / MARKET
 */
export function useExpoMedia(expoEvent) {
  const [videos, setVideos] = useState([])
  const [photos, setPhotos] = useState([])

  useEffect(() => {
    getExpoMediaList({ expo_event: expoEvent, media_type: MEDIA_TYPE.VIDEO })
      .then(setVideos)
      .catch((err) => console.error('Failed to fetch expo videos:', err))

    getExpoMediaList({ expo_event: expoEvent, media_type: MEDIA_TYPE.IMAGE })
      .then(setPhotos)
      .catch((err) => console.error('Failed to fetch expo photos:', err))
  }, [expoEvent])

  return { videos, photos }
}
